import { Helmet } from "react-helmet-async";
import { BrowserRouter } from "react-router";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import Routes from "components/Routes";
import AlertState from "context/alert/AlertState";
import AuthState from "context/auth/AuthState";
import DropzoneState from "context/dropzone/DropzoneState";
import LanguageState from "context/language/LanguageState";
import ParamsState from "context/params/ParamsState";
import RoutesState from "context/routes/RoutesState";
import SignalRState from "context/signalR/SignalRState";
import TimeZoneState from "context/timeZone/TimeZoneState";
import TutorialState from "context/tutorial/TutorialState";
import { ENVIRONMENTS, getEnvironment } from "shared";

const App = () => {
    const queryClient = new QueryClient();

    const { env } = getEnvironment();

    return (
        <>
            <Helmet>
                {env !== ENVIRONMENTS.Production && (
                    <meta name="robots" content="noindex, nofollow" />
                )}
            </Helmet>

            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <AlertState>
                        <TimeZoneState>
                            <ParamsState>
                                <LanguageState>
                                    <AuthState>
                                        <SignalRState>
                                            <TutorialState>
                                                <DropzoneState>
                                                    <RoutesState>
                                                        <Routes />
                                                    </RoutesState>
                                                </DropzoneState>
                                            </TutorialState>
                                        </SignalRState>
                                    </AuthState>
                                </LanguageState>
                            </ParamsState>
                        </TimeZoneState>
                    </AlertState>
                </BrowserRouter>
            </QueryClientProvider>
        </>
    );
};

export default App;
